// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","colorBlackA03":"rgba(14, 19, 24, 0.03)","colorBlackA07":"rgba(14, 19, 24, 0.07)","colorBlackA20":"rgba(14, 19, 24, 0.2)","mediaContainer":"_2DHNdhYVPUjHaEdKqqOvXY","mediaWrap":"_2tgQOSn_dFogH6nODbCahK","media":"_1JMQhlrG6YlLaYgIBQNdy2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/mediaContainer/mediaContainer.css
// module id = 1059
// module chunks = 0